
import { defineComponent, PropType } from 'vue'
import graphVis from '../utils/graphing/graph'
import { PaperID } from '@/types/incitefulTypes'
import {
  ArrowsExpandIcon,
  LocationMarkerIcon,
  ZoomInIcon,
  ZoomOutIcon,
  XCircleIcon
} from '@heroicons/vue/outline'
import { GraphData, IncitefulGraph } from '@/types/graphTypes'

export default defineComponent({
  name: 'GraphView',
  props: {
    graphData: {} as PropType<GraphData | undefined>,
    errorMsg: String,
    filteredIds: {} as PropType<Set<PaperID>>,
    highlightedIds: {} as PropType<Set<PaperID>>
  },
  components: {
    ArrowsExpandIcon,
    LocationMarkerIcon,
    ZoomInIcon,
    ZoomOutIcon,
    XCircleIcon
  },
  data () {
    return {
      cyInstance: {} as IncitefulGraph,
      isFullScreen: false
    }
  },
  mounted (): void {
    if (this.graphData && this.graphData.papers) this.loadGraph()
  },
  computed: {
    maxDate (): number {
      if (this.graphData) {
        return Math.max(
          ...Object.values(this.graphData.papers ?? {})
            .map(e => e.published_year)
            .filter(a => a)
        )
      }

      return 0
    },
    minDate (): number {
      if (this.graphData) {
        return Math.min(
          ...Object.values(this.graphData.papers ?? {})
            .map(e => e.published_year)
            .filter(a => a)
        )
      }
      return 0
    },
    slotHasContent (): boolean {
      return !!this.$slots.default && !!this.$slots.default
    }
  },
  watch: {
    graphData (newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        this.loadGraph()
      }
    },
    loaded (newVal, oldVal) {
      if (newVal && !oldVal) {
        this.loadGraph()
      }
    },
    isFullScreen (newVal) {
      this.$nextTick(() => {
        if (!newVal) {
          this.cyInstance.resize()
        }
      })
    },
    filteredIds (newVal) {
      this.cyInstance.filterNodes(newVal)
    },
    highlightedIds (newVal) {
      this.cyInstance.highlightNodes(newVal)
    }
  },
  methods: {
    loadGraph (): void {
      if (this.graphData) {
        const cy = graphVis.loadGraph(
          this.graphData,
          this.$refs.graph as HTMLElement,
          this.emitter,
          this.minDate,
          this.maxDate
        )

        this.cyInstance = Object.freeze(cy)
      }
    },
    toggleFullScreen (): void {
      this.isFullScreen = !this.isFullScreen
    },
    centerGraph (): void {
      this.cyInstance.centerSource()
    },
    zoomIn (): void {
      let curZoom = this.cyInstance.curZoom()

      if (curZoom > 1.35) {
        curZoom = 1.35
      }

      this.cyInstance.zoom(curZoom + 0.15)
    },
    zoomOut (): void {
      let curZoom = this.cyInstance.curZoom()

      if (curZoom < 0.3) {
        curZoom = 0.3
      }

      this.cyInstance.zoom(curZoom - 0.15)
    },
    closeFullScreen (): void {
      if (this.isFullScreen) this.isFullScreen = false
    }
  }
})
